// Horizon UI responsive breakpoints (plain object form, Chakra v2 compatible).
export const breakpoints = {
  sm: '320px',
  '2sm': '380px',
  md: '768px',
  lg: '960px',
  xl: '1200px',
  '2xl': '1600px',
  '3xl': '1920px'
};
